/* eslint-disable sonarjs/no-duplicate-string */
import type { ComponentStyleConfig, PartsStyleObject, SystemStyleObject } from '@chakra-ui/react';
import { accordionAnatomy as parts } from '@chakra-ui/anatomy';

const baseStyleContainer: SystemStyleObject = {
  borderTopWidth: '2px',
  borderLeftWidth: '2px',
  borderRightWidth: '2px',
  borderColor: 'brand.sand',
  marginBottom: 6,
  borderBottomWidth: '2px',
  _last: {
    borderBottomWidth: '2px',
  },
};

const baseStyleButton: SystemStyleObject = {
  transitionProperty: 'common',
  transitionDuration: 'normal',
  fontSize: '1rem',
  fontWeight: '500',
  _focusVisible: {
    boxShadow: 'outline',
  },
  _hover: {
    bg: 'transparent',
    color: 'brand.red.light',
  },
  _disabled: {
    opacity: 0.4,
    cursor: 'not-allowed',
  },
  _expanded: { color: 'brand.red.light', borderBottomWidth: 2 },
  px: 4,
  py: 2,
};

const baseStylePanel: SystemStyleObject = {
  px: 4,
  py: 5,
};

const baseStyleIcon: SystemStyleObject = {
  fontSize: '1.25em',
  color: 'brand.red.light',
};

const baseStyle: PartsStyleObject<typeof parts> = {
  root: {},
  container: baseStyleContainer,
  button: baseStyleButton,
  panel: baseStylePanel,
  icon: baseStyleIcon,
};

const accordionStyle: ComponentStyleConfig = {
  parts: parts.keys,
  baseStyle,
};

export default accordionStyle;
